import { useState } from "react";
import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalCloseButton,
  ModalBody,
  ModalFooter,
  Button,
  Text,
  useToast,
} from "@chakra-ui/react";

import { appRequest } from "routes";

type ModalProps = {
  isOpen: boolean;
  onClose: () => void;
  id?: string;
  handleGet: () => void;
  status:boolean
};

export default function DeleteFormModal({
  isOpen,
  onClose,
  id,
  handleGet,
  status
}: ModalProps): JSX.Element {
  const toast = useToast();
  const [deleteFormLoading, setDeleteFormLoading] = useState(false);

  const handleDelete = async () => {
    try {
      setDeleteFormLoading(true);
      const response: any = await appRequest("form", "delete", { id: id });
      if (response) {
        if (response.status && response.status === "success") {
          toast({
            title: `Form deleted successfully.`,
            description: `We've deleted your Form.`,
            status: "success",
            duration: 9000,
            isClosable: true,
            position: "top-right",
          });
          handleGet();
          onClose();
        } else {
          toast({
            title: `Error Deleting the Form.`,
            description: response.code || response.message,
            status: "error",
            duration: 9000,
            isClosable: true,
            position: "top-right",
          });
        }
      } else {
        toast({
          title: `Error Deleting the Form.`,
          description: response.message,
          status: "error",
          duration: 9000,
          isClosable: true,
          position: "top-right",
        });
      }
    } catch (error: any) {
      toast({
        title: `Error Deleting the Form.`,
        description: error.message || "Something went wrong.",
        status: "error",
        duration: 9000,
        isClosable: true,
        position: "top-right",
      });
    } finally {
      setDeleteFormLoading(false);
    }
  };
  return (
    <Modal isOpen={isOpen} onClose={onClose} isCentered>
      <ModalOverlay />
      <ModalContent>
        <ModalCloseButton />
        <ModalBody>
          <Text
            fontSize={{ base: "lg", md: "xl" }}
            fontWeight="500"
            color="red"
            mt={10}
            textAlign="center"
          >
            This action cannot be undone. Deleting this{" "}
            <Text as="span">Form</Text> will remove all associated
            permissions.
          </Text>
          <Text
            fontSize={{ base: "lg", md: "xl" }}
            fontWeight="700"
            color="red"
            mt={1}
            textAlign="center"
          >
            Please confirm?
          </Text>
        </ModalBody>

        <ModalFooter
          gap={6}
          mt={2}
          justifyItems="center"
          justifyContent="center"
          my={6}
        >
          <Button
            type="submit"
            w="70px"
            bg="teal.300"
            color="white"
            _hover={{
              bg: "teal.400",
            }}
            onClick={handleDelete}
            isLoading={deleteFormLoading}
            isDisabled={status}
          >
            Yes
          </Button>
          <Button onClick={onClose} colorScheme="red" color="white" w="70px">
            No
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
}
